<div [formGroup]="messageForm" class="messageForm create h-full">
  <div
    #list
    #userTableTrigger="cdkOverlayOrigin"
    cdkOverlayOrigin
    (click)="optionsListGeneralComponent.toggleShow()"
    class="form hide-underline w-full py-4"
  >
    <app-overlay-general
      #optionsListGeneralComponent
      (showChange)="!!$event ? loadUsers() : ''"
      [trigger]="userTableTrigger"
      [withAnimation]="false"
    >
      <app-messaging-users-table
        [listItems]="itemOptions"
        [usersRelated]="usersData.usersRelated"
        [discussionMembers]="usersData.discussionMembers"
        (selectedOption)="registerOption($event); optionsListGeneralComponent.toggleShow()"
      ></app-messaging-users-table>
    </app-overlay-general>

    <span prefix class="icon-at-sign text-navy-600 font-normal font-sm"></span>
    @for (user of usersData.discussionMembers; track user) {
      <span class="pr-5 text-navy-600 font-normal font-sm"> {{ user.name }} </span>
    }
    <input
      tabindex="-1"
      placeholder="Type a name..."
      class="participants clean-input"
      autocomplete="off"
      (click)="optionsListGeneralComponent.toggleShow(); $event.stopPropagation()"
      (input)="loadUsers()"
      formControlName="participants"
    />
    @if (messageForm.get('participants').invalid) {
      <mat-error>
        {{ getErrorMessage(messageForm.get('participants')) }}
      </mat-error>
    }
  </div>
  <div class="border-separator"></div>

  <div class="form hide-underline subject-input w-full py-4">
    <input
      #subjectInput
      name="subject"
      class="clean-input"
      formControlName="subject"
      placeholder="Group Name / Subject"
      (input)="updateMessagingGroup(subjectInput.value, 'name')"
    />
  </div>
  <div class="border-separator"></div>

  <app-rich-text-editor
    [editorValue]="editorValue"
    (editorValueChange)="onEditorValueChange($event)"
    [userMentions]="usersData.discussionMembers"
    [projectMentions]="projectMentions$ | async"
    [allowFileUpload]="true"
    [filesToUpload]="filesToUpload$ | async"
    (filesToUploadChange)="registerFileUpload($event)"
    (removedFileToUpload)="removeFile($event)"
    enterKeyPressBehaviour="custom"
    (enterKeyPress)="footerService.emitSave()"
    class="flex-1 min-h-0 mb-5"
  >
    <div class="right-button-container">
      <app-simple-button (click)="footerService.emitSave()" buttonStyle="color_accent_filled">Send</app-simple-button>
    </div>
  </app-rich-text-editor>
</div>
